'use strict';

/**
 * Hält das eproc-api-Token der Legacy-Oberfläche im sessionStorage aktuell (EPROC-12347).
 *
 * Beim Seitenaufbau schreibt oneframe (libHeadResources.vsl) das Token in den sessionStorage.
 * Nach jeder Erneuerung durch authCtrl muss es dort ebenfalls landen: die jQuery-Aufrufe
 * (custom_components/js/http.js) und die eingebetteten Seiten der neuen Oberfläche lesen es dort.
 */

// eproc-fe fordert im Rahmen 60 Sekunden vor Ablauf ein neues Token an (AuthSession
// IFRAME_REFRESH_LEEWAY_MS) und erwartet binnen 10 Sekunden ein anderes. Die Legacy-Oberfläche
// erneuert deshalb früher, damit das neue Token bis dahin schon bereitliegt.
const REFRESH_LEAD_SECONDS = 120;
const MIN_VALIDITY_SECONDS = 60;
// deutlich unter den 10 Sekunden, die eproc-fe auf ein neues Token wartet: die Antwort an den
// Rahmen braucht nach dem Warten noch etwas Zeit
const WAIT_TIMEOUT_MS = 6000;
const TOKEN_STORED_EVENT = 'eprocApiTokenStored';

function nowInSeconds() {
    return Math.floor(Date.now() / 1000);
}

/**
 * Speichert ein erneuertes Token samt Erstellzeit und Laufzeit, wie oneframe es beim Seitenaufbau tut.
 * @param data {{access_token: string, expires_in: number}} - Antwort von rest.refresh_access_token
 */
function storeAccessToken(data) {
    const storage = window.sessionStorage;
    storage.setItem(window.STORAGE_KEY.TOKEN, data.access_token);
    storage.setItem(window.STORAGE_KEY.EPROC_API_CREATION_TIME, String(nowInSeconds()));
    storage.setItem(window.STORAGE_KEY.EPROC_API_EXPIRES_IN, String(data.expires_in));
    window.dispatchEvent(new Event(TOKEN_STORED_EVENT));
}

function getAccessToken() {
    return window.sessionStorage.getItem(window.STORAGE_KEY.TOKEN);
}

/**
 * @return {number} volle Laufzeit des gespeicherten Tokens in Sekunden, wie sie bei der Ausgabe galt
 */
function getLifetimeSeconds() {
    return +window.sessionStorage.getItem(window.STORAGE_KEY.EPROC_API_EXPIRES_IN);
}

/**
 * @return {number} Sekunden bis zum Ablauf des gespeicherten Tokens, negativ wenn abgelaufen
 */
function getRemainingSeconds() {
    const creationTime = +window.sessionStorage.getItem(window.STORAGE_KEY.EPROC_API_CREATION_TIME);
    return creationTime + getLifetimeSeconds() - nowInSeconds();
}

/**
 * Wartet, bis das gespeicherte Token noch mindestens MIN_VALIDITY_SECONDS gilt. Läuft es vorher ab,
 * wartet die Funktion auf die Erneuerung durch authCtrl, statt selbst zu erneuern: zwei gleichzeitige
 * Erneuerungen mit demselben Refresh-Token widerruft die API als Wiederverwendung.
 * Nach WAIT_TIMEOUT_MS geht es auch ohne Erneuerung weiter. Ohne Token (z. B. nach einer gescheiterten
 * Erneuerung, die das Token leert) gibt es nichts abzuwarten, dann geht es sofort weiter.
 * @return {Promise<void>}
 */
function waitForUsableAccessToken() {
    if (!getAccessToken() || getRemainingSeconds() > MIN_VALIDITY_SECONDS) {
        return Promise.resolve();
    }

    return new Promise((resolve) => {
        const done = () => {
            window.clearTimeout(timeoutId);
            window.removeEventListener(TOKEN_STORED_EVENT, done);
            resolve();
        };
        const timeoutId = window.setTimeout(done, WAIT_TIMEOUT_MS);
        window.addEventListener(TOKEN_STORED_EVENT, done);
    });
}

module.exports = {
    REFRESH_LEAD_SECONDS,
    storeAccessToken,
    getAccessToken,
    getLifetimeSeconds,
    getRemainingSeconds,
    waitForUsableAccessToken,
};
